var map = {
	"./1.jpg": 211,
	"./10.jpg": 212,
	"./2.jpg": 213,
	"./3.jpg": 214,
	"./4.jpg": 215,
	"./5.jpg": 216,
	"./6.jpg": 217,
	"./7.jpg": 218,
	"./8.jpg": 219,
	"./9.jpg": 220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;